/**
 * Escapes characters that have special meaning in HTML so that the result can
 * be safely inserted into an HTML context (e.g. via `v-html`) without being
 * interpreted as markup.
 */
export function escapeHtml(text: string): string {
  return String(text)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}
